import {
  CartesianGrid,
  Label,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { randomColorPicker } from "../../../../../../../../../../utils/randomColorPicker";
import { chartDomainChecker } from "../../../../../../../../../../utils/chartDomainChecker";
import { VisualizationData } from "../../../types";
import useChartYaxis from "../../../../../../../hooks/useChartYaxis";
import ChartWithTooltip from "../components/ChartWithTooltip";
import { CustomTick } from "../components/CustomTick";
import { CustomYAxisLabel } from "../components/CustomYAxisLabel";

type Props = {
  chart: VisualizationData;
};

const CustomLineChart = ({ chart }: Props) => {
  const { maxTickWidth, calc, handleTickWidth, tooltip, tooltipHandler } =
    useChartYaxis(chart);
  return (
    <ChartWithTooltip tooltip={tooltip} label={chart.y_axis_name}>
      <ResponsiveContainer width="100%" height={250}>
        <LineChart
          data={chart.data}
          margin={{ top: 20, right: 30, left: 0, bottom: 0 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey={chart.x_axis_name}
            domain={chartDomainChecker(chart.range.x_range)}
          />
          <YAxis
            width={maxTickWidth + 10}
            padding={{ top: 10 }}
            tick={
              <CustomTick
                tooltipHandler={tooltipHandler}
                exponent={calc.exponent}
                onTickWidth={handleTickWidth}
              />
            }
            dataKey={chart.y_axis_name}
            domain={chartDomainChecker(chart.range.y_range)}
          >
            <Label
              content={
                <CustomYAxisLabel
                  startingX={maxTickWidth}
                  exponent={calc.exponent}
                />
              }
            />
          </YAxis>
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey={chart.y_axis_name}
            stroke={randomColorPicker()}
          />
        </LineChart>
      </ResponsiveContainer>
    </ChartWithTooltip>
  );
};

export default CustomLineChart;
